import * as transformers from '@attain-apps/transformers'

import { IN, OUT } from './factories'

export const AWS_SCALARS = new transformers.common.AwsScalarTransformers({
  factories: {
    entityToGraphql: IN,
    graphqlToEntity: OUT,
  },
})
